import { Component, OnInit } from '@angular/core';
import { ExamService } from 'src/app/services/Exam/exam.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { GlobalHelper } from 'src/app/services/Common/global.service';


@Component({
  selector: 'app-personal-skill-activity',
  templateUrl: './personal-skill-activity.component.html',
  styleUrls: ['./personal-skill-activity.component.css']
})
export class PersonalSkillActivityComponent implements OnInit {

  constructor(private examService:ExamService,private lookupService: LookupService, private globalHelper: GlobalHelper,     private spinnerService: Ng4LoadingSpinnerService) { }
  PersonalSkillActivityModel =
                  {
                      PersonalSkillActivityID: 0,
                      PersonalSkillId: 0,
                      ActivityName: '',
                      ActivityDescription: '',
                     
                      IsActive: true,
                      Skill:"",
                      Description:""
                  };

                  Submitted = false;
        Clear  () {
            this.PersonalSkillActivityModel.PersonalSkillActivityID = 0;
            this.PersonalSkillActivityModel.PersonalSkillId = 0;
            this.PersonalSkillActivityModel.ActivityName = '';
            this.PersonalSkillActivityModel.ActivityDescription = '';
            this.PersonalSkillActivityModel.IsActive = true;
            this.Submitted = false;
        };


         ValidateDropdown() {
            return this.PersonalSkillActivityModel.PersonalSkillId == 0
        };

        SavePersonalSkillActivity  (valid) {
            this.Submitted = true;
            if (valid && !this.ValidateDropdown()) {
                
                this.examService.SavePersonalSkillActivity(JSON.stringify(this.PersonalSkillActivityModel)).subscribe( (response)=> {
                  
                    this.SearchAllPersonalSkill();
                   this.globalHelper.CheckActionStatus(response);
                    this.Clear();
                })
            }
        };
        PersonalSkillActivityList:any;
        SearchAllPersonalSkill  () {
            this.spinnerService.show();
            this.examService.SearchAllPersonalSkill().subscribe( (response)=> {
                this.PersonalSkillActivityList = response.PersonalSkillActivityList;
                this.spinnerService.hide();
                this.globalHelper.CheckActionStatus(response);
            });
        };


        PersonalSkillList:any;
        GetPersonalSkill  () {
            this.lookupService.GetLookupsList('PersonalSkill', '').subscribe( (data)=> {
                this.PersonalSkillList = data.LookupItems;
            });
        };

        Edit  (obj) {
            this.PersonalSkillActivityModel.PersonalSkillActivityID = obj.PersonalSkillActivityID;
            this.PersonalSkillActivityModel.PersonalSkillId = obj.PersonalSkillId;
            this.PersonalSkillActivityModel.Skill = obj.Skill;
            this.PersonalSkillActivityModel.Description = obj.Description;
            this.PersonalSkillActivityModel.ActivityName = obj.ActivityName;
            this.PersonalSkillActivityModel.ActivityDescription = obj.ActivityDescription;
            this.PersonalSkillActivityModel.IsActive = obj.IsActive;
        }

        GetStatus  (IsActive) {
            return IsActive ? 'Yes' : 'No';
        };

      

  ngOnInit() {
    this.SearchAllPersonalSkill();
    this.GetPersonalSkill();
  }


}
